// Audio
export const BG_MUSIC = "game-song";
export const BG_MUSIC_VOLUME = 0.8;
export const RING_SOUND = "ring";
export const RING_SOUND_VOLUME = 0.2;
export const ENEMY_SOUND_DESTROY = "destroy";
export const ENEMY_SOUND_HYPER_RING = "hyper-ring";
export const ENEMY_SOUND_VOLUME = 0.2;
export const ENEMY_HURT_SOUND = "hurt";
export const JUMP_SOUND = "jump";
export const JUMP_SOUND_VOLUME = 0.25;

// Physics
export const GRAVITY = 3100;
export const JUMP_FORCE = 1700;

// Background
export const BG_IMAGES = ["toma-1", "toma-2", "toma-3", "toma-4", "toma-5", "toma-6"] as const;
export const BG_TRANSITION_TIMES = [0, 18, 34, 48, 63, 93 ]; // seconds into game
export const BG_SCALE = 5; // 384 * 5 = 1920 (full screen width)
export const BG_PARALLAX_DIVISOR = 10;
export const BG_PARALLAX_OFFSET = -50;
export const GAME_DURATION = 120; // seconds

// Platforms
export const PLATFORM_IMAGE = "platforms";
export const PLATFORM_Y_POS = 450;
export const PLATFORM_SCALE = 4;
export const PLATFORM_OPACITY = 0;
export const PLATFORM_WIDTH = 1920;
export const PLATFORM_HEIGHT = 300;
export const PLATFORM_BODY_Y_POS = 832;

// Player
export const SONIC_START_X = 200;
export const SONIC_START_Y = 745;
export const SONIC_SCALE = 4;
export const SONIC_UI_FONT_SIZE = 24;
export const SONIC_UI_OFFSET_X = 30;
export const SONIC_UI_OFFSET_Y = -10;
export const SONIC_UI_COLOR: [number, number, number] = [255, 255, 0];

// Controls text
export const CONTROLS_TEXT = "";
export const CONTROLS_FONT = "mania";
export const CONTROLS_FONT_SIZE = 64;

// Score UI
export const SCORE_TEXT_PREFIX = "PUNTAJE:";
export const SCORE_FONT = "mania";
export const SCORE_FONT_SIZE = 72;
export const SCORE_TEXT_X = 20;
export const SCORE_TEXT_Y = 20;
export const SCORE_MULTIPLIER = 2;
export const RING_SCORE = 3;
export const RING_COLLECT_UI_DURATION = 1;

// Game speed
export const GAME_SPEED_INITIAL = 40;
export const GAME_SPEED_INCREMENT = 28;
export const GAME_SPEED_MAX = 1750;

// Entity spawn positions
export const MOTOBUG_START_X = 1950;
export const MOTOBUG_START_Y = 773;
export const RING_START_X = 1950;
export const RING_START_Y = 745;

// Motobug hitbox
export const MOTOBUG_HITBOX_WIDTH = 32;
export const MOTOBUG_HITBOX_HEIGHT = 32;
export const MOTOBUG_HITBOX_OFFSET_X = -5;
export const MOTOBUG_HITBOX_OFFSET_Y = 0;

// Escalera
export const ESCALERA_START_X = 1950;
export const ESCALERA_START_Y = 700;
export const ESCALERA_SCALE = 3;
export const ESCALERA_BOB_AMPLITUDE = 15;
export const ESCALERA_BOB_SPEED = 4;
export const ESCALERA_TILT_AMPLITUDE = 0.05;
export const ESCALERA_TILT_SPEED = 3;
export const ESCALERA_HITBOX_WIDTH = 40;
export const ESCALERA_HITBOX_HEIGHT = 28;
export const ESCALERA_MIN_SPAWN_WAIT = 5;
export const ESCALERA_MAX_SPAWN_WAIT = 12;
export const ESCALERA_SPEED_BONUS = 200;
export const ESCALERA_DELAY = 34; // seconds before escalera starts spawning
export const ESCALERA_SCORE = 10;

// Spawn timing
export const MIN_SPAWN_WAIT_TIME = 0.7;
export const MAX_SPAWN_WAIT_TIME = 3.5;

// Scenes
export const MENU_SCENE = "menu";
export const GAME_SCENE = "game";
export const GAME_OVER_SCENE = "gameover";
export const SUBMIT_SCENE = "submit";

// Menu UI
export const MENU_TITLE_TEXT = "ENTORNO BIAI";
export const MENU_TITLE_FONT_SIZE = 120;
export const MENU_TITLE_OFFSET_Y = -420;
export const MENU_SUBTITLE_TEXT = "LEADERBOARD";
export const MENU_SUBTITLE_FONT_SIZE = 64;
export const MENU_SUBTITLE_OFFSET_Y = -320;
export const MENU_LEADERBOARD_FONT_SIZE = 40;
export const MENU_LEADERBOARD_START_Y = -230;
export const MENU_LEADERBOARD_ROW_SPACING = 50;
export const MENU_LEADERBOARD_MAX_ENTRIES = 10;
export const MENU_LEADERBOARD_NAME_MAX_LEN = 12;
export const MENU_LOADING_TEXT = "CARGANDO...";
export const MENU_EMPTY_TEXT = "SIN PUNTAJES";
export const MENU_PLAY_TEXT = "Presiona /Click/Touch para Jugar";
export const MENU_PLAY_FONT_SIZE = 64;
export const MENU_PLAY_OFFSET_Y = 380;
export const MENU_PLAY_DELAY = 0.5;

// Game over UI
export const GAMEOVER_TITLE_FONT_SIZE = 96;
export const GAMEOVER_TEXT_FONT_SIZE = 64;
export const GAMEOVER_RANK_FONT_SIZE = 100;
export const GAMEOVER_RANK_BOX_SIZE = 400;
export const GAMEOVER_RANK_BOX_RADIUS = 4;
export const GAMEOVER_RANK_BOX_OUTLINE = 6;
export const GAMEOVER_TITLE_OFFSET_Y = -300;
export const GAMEOVER_SCORE_OFFSET_Y = -200;
export const GAMEOVER_RANK_OFFSET_Y = 50;
export const GAMEOVER_COLUMN_OFFSET_X = 400;
export const GAMEOVER_RESTART_OFFSET_Y = 350;
export const GAMEOVER_RESTART_DELAY = 1;

// Rank thresholds (ascending order, strict greater-than)
export const RANK_GRADES = ["F", "E", "D", "C", "B", "A", "S"] as const;
export const RANK_VALUES = [50, 80, 100, 200, 300, 400, 500] as const;

// Intro scene
export const INTRO_SCENE = "intro";
export const INTRO_RIDER_SPEED = 300;
export const INTRO_RIDER_SCALE = 8;
export const INTRO_RIDER_Y = 1020;
export const INTRO_BG_SPRITE = "intro-bg";

// Intro zones — layout (left to right, scale 3)
export const INTRO_FURNITURE_Y = 1020;
export const INTRO_FURNITURE_SCALE = 3;

export const INTRO_TREE_SPRITE = "tree";
export const INTRO_TREE_X = 1800;


export const INTRO_CABINET_SPRITE = "cabinet";
export const INTRO_CABINET_X = 840;
export const INTRO_SHOP_URL = "https://entornobiai.com";

export const INTRO_SALES_WOMAN_SPRITE = "sales-woman";
export const INTRO_SALES_WOMAN_X = 840;
export const INTRO_SALES_WOMAN_SCALE = 7;

export const INTRO_ARCADE_SPRITE = "arcade";
export const INTRO_ARCADE_X = 510;

export const INTRO_DOG_SPRITE = "husky";
export const INTRO_DOG_X = 1100;
export const INTRO_DOG_SCALE = 5;
export const INTRO_DOG_SPEED = 150;
export const INTRO_DOG_STOP_DISTANCE = 120;
export const INTRO_DOG_PET_DURATION = 2;

export const INTRO_REGISTER_SPRITE = "register-desk";
export const INTRO_REGISTER_X = 1240;
export const INTRO_REGISTER_PERSON_SPRITE = "register-person";
export const INTRO_REGISTER_PERSON_X = 1240;
export const INTRO_REGISTER_PERSON_SCALE = 7;

export const INTRO_REPAIR_SPRITE = "repair-station";
export const INTRO_REPAIR_X = 1650;
export const INTRO_REPAIR_PHONE_URL = "https://www.entornobiai.com/reparacion-de-celulares";
export const INTRO_REPAIR_PC_URL = "https://www.entornobiai.com/reparacion-de-computadores";
export const INTRO_REPAIR_WORKER_SPRITE = "repair-worker";
export const INTRO_REPAIR_WORKER_X = 1650;
export const INTRO_REPAIR_WORKER_SCALE = 7;

export const INTRO_EDUCATION_SPRITE = "education-desk";
export const INTRO_EDUCATION_X = 250;
export const INTRO_EDUCATION_URL = "https://www.entornobiai.com/educacion";
export const INTRO_EDUCATION_WORKER_SPRITE = "education-worker";
export const INTRO_EDUCATION_WORKER_X = 250;
export const INTRO_EDUCATION_WORKER_SCALE = 5;

// API
export const API_BASE_URL = import.meta.env.VITE_API_URL || "";

// Auth0
export const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN || "";
export const AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID || "";
export const AUTH0_AUDIENCE = import.meta.env.VITE_AUTH0_AUDIENCE || "";
